<template>
    <div class="flex flex-col gap-[10px] md:gap-[20px]">
        <TitleBlockStat title="Top Platforms" info-text="all platforms"
            :info-link="route(`${prefixRoute}.platform.index`)"></TitleBlockStat>

        <ul class="flex flex-col divide-y divide-slate-200">
            <li v-for="platform in platformsWithPercentage" :key="platform.id"
                class="flex justify-between py-[10px] relative">
                <div class="absolute top-0 left-0 h-full bg-blue-100 transition-all duration-500 ease-out"
                    :style="{ width: `${platform.percentage}%` }"></div>

                <div class="relative z-10 flex justify-between w-full px-2">
                    <strong>{{ platform.name }}</strong>
                    <span>{{ platform.mentionsCount }}</span>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import TitleBlockStat from '@/Components/BrandMonitoring/TitleBlockStat.vue';

const props = defineProps({
    data: Object,
    prefixRoute: String,
    totalMentions: {
        type: Number,
        default: 1000
    }
});

const platformsWithPercentage = computed(() => {
    return props.data.platforms.map(platform => ({
        ...platform,
        percentage: props.totalMentions > 0
            ? Math.round((platform.mentionsCount / props.totalMentions) * 100 * 10) / 10
            : 0
    }));
});
</script>

<style scoped>
li div[class*="bg-blue"] {
    border-radius: 0 3px 3px 0;
}

hlword {
    font-weight: bold;
    background-color: #f8fafc;
    display: inline-block;
}
</style>